import {Combo} from '@mintdata-wsp/common/components/combo/Combo';
import {User} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Tooltip} from '@mintdata-wsp/mint-kit/impl/components/tooltip/Tooltip';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ProfilePopupCard} from '@mintdata-wsp/wsp/ui/views/workspace/userBar/profile/ProfilePopupCard';
import {IListItemState, ListModel} from '@mintdata/mint-kit/api/models/List';
import {PopupAnchor, PopupSize, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IStyles} from '@mintdata/mint-kit/impl/util/Styles';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./ProfileButton.less');
const cx = classnames.bind(styles);

export interface ProfileButtonProps
{
    className?:string;
    captionClassName?:string;
}

@observer
export class ProfileButton extends React.Component<ProfileButtonProps, any>
{
    @bind
    _captionRenderer(data:any, state:any, styles:IStyles):JSX.Element
    {
        if( !controllers.user.isLoggedIn() )
            return null;

        const avatarUrl = rootState.userSession.currentUser.avatarUrl;
        if( avatarUrl )
            return (
                <Row className={cx('caption', this.props.captionClassName)}>
                    <img src={avatarUrl} className={cx('avatar')} />
                </Row>
            );

        const label = User.initials(rootState.userSession.currentUser);
        return (
            <Row className={cx('caption', this.props.captionClassName)}>
                {label}
            </Row>
        );

    }

    @bind
    _itemsRenderer(data:any, state:IListItemState, styles:IStyles):JSX.Element
    {
        if( !controllers.user.isLoggedIn() )
            return null;

        const user = rootState.userSession.currentUser;
        return <ProfilePopupCard user={user} />;
    }

    render()
    {
        if( !rootState.userSession || !rootState.userSession.currentUser )
            return null;

        const {currentUser} = rootState.userSession;
        const {className} = this.props;

        const items = [{label: User.initials(currentUser), data: currentUser}];
        const listModel = new ListModel(items);
        listModel.selectFirstItem();

        return <Tooltip
            tooltipClassName={cx('tooltip')}
            showArrow={false}
            closeOnTargetClick={true}
            content={'Profile'}
            popoverProps={{
                className: cx('tooltipPopover'),
                sourceAnchor: SourceAnchor.CenterBottom,
                popupAnchor: PopupAnchor.CenterTop,
                ignoreEsc: true
            }}
            hoverOpenDelay={500}
        >
            <div className={cx('profileButton', className)}>    
                <Combo dataSource={listModel}
                    // onSelectItem={this._onOrganizationSelected}
                    contentRenderer={this._captionRenderer}
                    itemRenderer={this._itemsRenderer}
                    sourceAnchor={SourceAnchor.RightBottom}
                    popoverAnchor={PopupAnchor.RightTop}
                    popupSize={PopupSize.Original}
                    theme={{content: styles.popupContent}}
                >
                </Combo>
            </div>
        </Tooltip>;
    }
}
